/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */

import * as yup from "yup";

import React, { useContext, useEffect, useState } from "react";
import {
  contractById,
  getCompany,
  getMaestras,
  renewContract,
  saveContract,
} from "../../actions/generation-contarct-action";
import {
  getProvinces,
  getTownsByProvinceId,
} from "../../actions/location-actions";

import { DataContext } from "../../context/reducers/contextSearchUser";
import DialogCost from "../../componentes/searchContracts/dialogCost";
import InfoContract from "./informationContract/infoContract";
import ModalConfirm from "../../utils/form/modalConfirmBase";
import { REQUIRED_MESSAGE } from "../../constants";
import { getActiveRegionals } from "../../actions/regional-actions";
import { getChargesByStatusActive } from "../../actions/charge-actions";
import { getProfessionAutocomplete } from "../../actions/profession-actions";
import { initialContract } from "./headers";
import moment from "moment";
import { useForm } from "react-hook-form";
import { useStateValue } from "../../context/store";
import { withRouter } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const InfoMainContract = (props) => {
  const _ = require("lodash");
  const {
    inputDisabled,
    dataUser,
    documentUser,
    idContractType,
    idContract,
    valVacancy,
  } = props;
  const { contractSalary } = useContext(DataContext);
  const [{}, dispatch] = useStateValue();
  const [contract, setContract] = useState(initialContract);
  const [department, setDepartment] = useState([]);
  const [citys, setCitys] = useState([]);
  const [company, setCompany] = useState([]);
  const [charges, setCharges] = useState([]);
  const [getDeparmenId, setGetDepartmentId] = useState("");
  const [citysResidence, setCitysResidence] = useState([]);
  const [maestras, setMaestras] = useState([]);
  const [professions, setProfessions] = useState([]);
  const [regionals, setRegionals] = useState([]);
  const [disableFinalDate, setDisableFinalDate] = useState(false);
  const [disableSalary, setDisableSalary] = useState(false);
  const [isContractApprenti, setIsContractApprenti] = useState(false);
  const [isSena, setIsSena] = useState(false);
  const [openModalCost, setOpenModalCost] = useState(false);
  const [idContractResponse, setIdContractResponse] = useState("");
  const [dataContract, setDataContract] = useState({});
  const soloLetras = /^(([A-Za-zÀ-ÿ])+[ ]?)*$/g;
  const [stateSalary, setStateSalary] = useState(false);
  const [isCheckSena, setIsCheckSena] = useState(false);
  const [isObraLaborFieldsDisabled, setIsObraLaborFieldsDisabled] =
    useState(false);
  const [professionList, setProfessionList] = useState([]);
  const [messageErrorProfession, setMessageErrorProfession] = useState("");
  const [chargesList, setChargesList] = useState([]);
  const [isLaborDisable, setIsLaborDisable] = useState(false);

  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const validateBirdtDate = () => {
    const currentyear = moment().year() - 1;
    return moment(currentyear + "-12-31").toDate();
  };

  const schema = yup.object().shape({
    firstName: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(soloLetras, "Ingrese un nombre válido"),
    secondName:
      contract?.secondName === ""
        ? null
        : yup
            .string()
            .notRequired()
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(80, "Ingrese máximo 80 caracteres")
            .matches(soloLetras, "Ingrese un nombre válido"),
    surname: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(80, "Ingrese máximo 80 caracteres")
      .matches(soloLetras, "Ingrese un apellido válido"),
    secondSurname:
      contract?.secondSurname === ""
        ? null
        : yup
            .string()
            .notRequired()
            .min(3, "Ingrese mínimo 3 caracteres")
            .max(80, "Ingrese máximo 80 caracteres")
            .matches(soloLetras, "Ingrese un apellido válido"),
    dateBirth: yup
      .date()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(
        new Date(1899, 11, 31, 23, 59, 29),
        `Ingrese una fecha superior al año 1900`
      )
      .max(validateBirdtDate(), `La fecha debe ser menor al año actual`)
      .typeError("Ingrese un formato de fecha válido"),
    charge: yup.string().nullable().required(REQUIRED_MESSAGE),
    regionalId: yup.string().nullable().required(REQUIRED_MESSAGE),
    nationality: yup
      .string()
      .min(4, "Ingrese mínimo 4 caracteres")
      .max(100, "Ingrese máximo 100 caracteres")
      .required(REQUIRED_MESSAGE)
      .matches(/^([^0-9]*)$/, "Ingrese una nacionalidad válida"),
    salary: contractSalary
      ? stateSalary
        ? null
        : yup
            .number()
            .nullable()
            .notRequired()
            .min(5, "Ingresar mínimo 5 dígitos")
            .max(20, "Ingresar máximo 20 dígitos")
      : yup
          .string("Ingrese un número válido")
          .required(REQUIRED_MESSAGE)
          .min(5, "Ingresar mínimo 5 dígitos")
          .max(20, "Ingresar máximo 20 dígitos")
          .required(REQUIRED_MESSAGE),
    paymentPeriod: yup.string().required(REQUIRED_MESSAGE),
    workplace: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(4, "Ingrese mínimo 4 caracteres")
      .max(100, "Ingrese máximo 100 caracteres"),
    hiringPlace: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(4, "Ingrese mínimo 4 caracteres")
      .max(100, "Ingrese máximo 100 caracteres"),
    workStartDate: yup
      .date()
      .nullable()
      .required(REQUIRED_MESSAGE)
      .min(
        new Date(1899, 11, 31, 23, 59, 29),
        `Ingrese una fecha superior al año 1900`
      )
      .typeError("Ingrese un formato de fecha válido"),
    department: yup.string().nullable().required(REQUIRED_MESSAGE),
    municipality: yup.string().nullable().required(REQUIRED_MESSAGE),
    cityResidence: yup.string().nullable().required(REQUIRED_MESSAGE),
    departmentResidence: yup.string().nullable().required(REQUIRED_MESSAGE),
    profession: yup.string().nullable().required(REQUIRED_MESSAGE),
    formationLevel: yup.string().nullable().required(REQUIRED_MESSAGE),
    address: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(60, "Ingrese máximo 60 caracteres"),
    workEndDate: disableFinalDate
      ? null
      : yup
          .date()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(
            new Date(1899, 11, 31, 23, 59, 29),
            `Ingrese una fecha superior al año 1900`
          )
          .nullable()
          .typeError("Ingrese un formato de fecha válido"),
    documentIssuancePlace: yup
      .string()
      .required(REQUIRED_MESSAGE)
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(60, "Ingrese máximo 60 caracteres")
      .matches(soloLetras, "Ingrese un lugar de expedición válido"),
    personalEmail: !isContractApprenti
      ? null
      : yup
          .string()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(8, "Ingrese mínimo 8 caracteres")
          .max(50, "Ingrese máximo 50 caracteres")
          .email("Ingrese un correo electrónico válido"),
    specialty: !isContractApprenti
      ? null
      : yup
          .string()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(100, "Ingrese máximo 100 caracteres"),
    groupNumber: !isContractApprenti
      ? null
      : yup
          .string()
          .nullable()
          .max(60, "Ingrese máximo 60 caracteres")
          .matches(/^(([0-9])+?)*$/g, "Ingrese solo números"),
    eps: !isContractApprenti
      ? null
      : yup
          .string()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(50, "Ingrese máximo 50 caracteres"),
    arl: !isContractApprenti
      ? null
      : yup
          .string()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(50, "Ingrese máximo 50 caracteres"),
    stratus: !isContractApprenti
      ? null
      : yup.string().nullable().required(REQUIRED_MESSAGE),
    trainingInstitution: !isContractApprenti
      ? null
      : yup
          .string()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(50, "Ingrese máximo 50 caracteres"),
    trainingInstitutionNit: !isContractApprenti
      ? null
      : yup
          .string()
          .nullable()
          .notRequired()
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(50, "Ingrese máximo 50 caracteres")
          .transform((v) => (v ? v : null)),
    trainingCenter: !isCheckSena
      ? null
      : yup
          .string()
          .nullable()
          .required(REQUIRED_MESSAGE)
          .min(3, "Ingrese mínimo 3 caracteres")
          .max(50, "Ingrese máximo 50 caracteres"),
    cellPhoneNumber: yup
      .string()
      .nullable()
      .transform((value) =>
        value
          .replace(/\s+/g, "")
          .split(" ")
          .join("")
          .replace("(", "")
          .replace(")", "")
          .replace("-", "")
          .replace(" ", "")
          .trim()
      )
      .required(REQUIRED_MESSAGE)
      .min(10, "Ingrese mínimo 10 dígitos"),
    phoneUser: yup
      .string()
      .transform(function (value) {
        let valor = value
          ?.replace(/\(/g, "")
          ?.replace(/\)/g, "")
          ?.replace(/\-/g, "")
          ?.replace(/\s+/g, "");
        if (valor === "") return null;
        return valor;
      })
      .notRequired()
      .nullable(true)
      .min(10, "Ingrese indicativo y mínimo 7 dígitos"),
    gender: yup.string().nullable().required(REQUIRED_MESSAGE),
    chargeIdToReplace: yup.string(),
    // .when([], {
    //   // is: () => isObraLaborFieldsDisabled || isLaborDisable,
    //   // then: yup.string().nullable().required(REQUIRED_MESSAGE),
    //   otherwise: yup.string().nullable().notRequired(),
    // }),
    employeeNameToReplace: yup.string().when([], {
      is: () => isObraLaborFieldsDisabled,
      then: yup
        .string()
        .required(REQUIRED_MESSAGE)
        .trim()
        .min(3, "Ingrese mínimo 3 caracteres")
        .max(200, "Ingrese máximo 200 caracteres")
        .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido"),
      otherwise: yup.string().notRequired(),
    }),
    reasonForReplacement: yup.string().when([], {
      is: () =>
        isObraLaborFieldsDisabled || isLaborDisable || isContractApprenti,
      then: yup
        .string()
        .trim()
        .notRequired()
        .nullable()
        .max(5000, "Ingrese máximo 5000 caracteres"),
      otherwise: yup.string().notRequired(),
    }),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    initialContract,
    mode: "all",
    reValidateMode: "onChange",
  });

  const isDisabledBtnGenerate = (state) => {
    dispatch({
      type: "IS_DISABLED_BTN_CONTRACT",
      stateBtn: state,
    });
  };

  useEffect(() => {
    if (dataUser?.data?.profession) {
      getProfessionByValue(dataUser?.data?.profession);
    }
  }, [dataUser]);

  useEffect(() => {
    if (idContractType === "CONTRATO_OBRA_LABOR_REEMPLAZO") {
      setIsObraLaborFieldsDisabled(true);
    } else {
      setIsObraLaborFieldsDisabled(false);
    }
    if (idContractType === "CONTRATO_POR_OBRA_LABOR") {
      setIsLaborDisable(true);
    } else {
      setIsLaborDisable(false);
    }
    if (
      idContractType === "CONTRATO_TERMINO_INDEFINIDO" ||
      idContractType === "CONTRATO_POR_OBRA_LABOR" ||
      idContractType === "CONTRATO_TERMINO_INDEFINIDO_PRIMERA_VEZ"
    ) {
      setDisableFinalDate(true);
    } else {
      setDisableFinalDate(false);
    }

    if (idContractType === "CONTRATO_PRESTACION_DE_SERVICIO") {
      setDisableSalary(true);
    } else {
      setDisableSalary(false);
    }

    if (idContractType === "CONTRATO_DE_APRENDIZAJE") {
      setIsContractApprenti(true);
    } else {
      setIsContractApprenti(false);
    }
  }, [idContractType]);

  useEffect(() => {
    const getListProvinces = async () => {
      const response = await getProvinces();
      setDepartment(response?.data?.provinceList);
      if (idContract) {
        const getContractById = async () => {
          const resp = await contractById(idContract);
          const employee = resp?.data;
          autoCompleteFied(employee);
          getListDepartmets(response?.data?.provinceList, employee?.employee);
        };
        getContractById();
      }
      // precargar lugar de residencia
      if (dataUser?.data && !idContract) {
        const filterDepartment = response?.data?.provinceList.filter(
          (x) => x?.name === dataUser?.data?.provinceResidence
        );
        const departmentResidence = filterDepartment
          .map((x) => x?.id)
          .toString();
        setValue("departmentResidence", departmentResidence);
        const cityResidence = dataUser?.data?.townResidence
          ?.toLowerCase()
          .split(" ")
          .map((word) => {
            return word.charAt(0).toUpperCase() + word.slice(1);
          });
        const city = cityResidence?.toString()?.replace(/\,/g, " ");
        getCityHomeByName(departmentResidence, city);
      }
    };
    getListProvinces();
  }, [idContract]);

  const autoCompleteFied = (employee) => {
    if (idContract) {
      setValue("firstName", employee?.employee?.firstName);
      setValue(
        "secondName",
        employee?.employee?.secondName ? employee?.employee?.secondName : null
      );
      setValue("surname", employee?.employee?.surname);
      setValue(
        "secondSurname",
        employee?.employee?.secondSurname
          ? employee?.employee?.secondSurname
          : null
      );
      setValue(
        "documentType",
        employee?.employee?.documentType
          ? employee?.employee?.documentType
          : null
      );
      setValue(
        "document",
        employee?.employee?.document ? employee?.employee?.document : null
      );
      setValue("dateBirth", moment(employee?.employee?.dateBirth)?.format());
      setValue("charge", employee?.charge?.id);
      setValue("regionalId", employee?.regional?.id);
      setValue("nationality", employee?.employee?.nationality);
      setValue(
        "salary",
        idContractType !== "CONTRATO_PRESTACION_DE_SERVICIO"
          ? employee?.salary
          : ""
      );
      setValue("paymentPeriod", employee?.paymentPeriod);
      setValue("workplace", employee?.employee?.workplace);
      setValue("hiringPlace", employee?.hiringPlace);
      setValue("workStartDate", employee?.workStartDate);
      setValue("address", employee?.employee?.address);
      setValue("workEndDate", employee?.workEndDate);
      setValue(
        "documentIssuancePlace",
        employee?.employee?.documentIssuancePlace
      );
      setValue("cityResidence", employee?.employee?.cityResidence);
      setValue("formationLevel", employee?.formationLevel);
      setValue("personalEmail", employee?.employee?.personalEmail);
      setValue("cellPhoneNumber", employee?.employee?.cellPhoneNumber);
      setValue("phoneUser", employee?.employee?.phone);
      setValue("gender", employee?.employee?.gender);
      getProfessionByValue(employee?.profession, "", "isRenew");
    }
  };

  const getValuesFormByPostulate = () => {
    if (valVacancy?.id) {
      setValue("firstName", valVacancy?.person?.firstName);
      setValue(
        "secondName",
        valVacancy?.person?.secondName ? valVacancy?.person?.secondName : null
      );
      setValue("surname", valVacancy?.person?.surname);
      setValue(
        "secondSurname",
        valVacancy?.person?.secondSurname
          ? valVacancy?.person?.secondSurname
          : null
      );
      setValue("dateBirth", moment(valVacancy?.person?.dateBirth).format());
      setValue("departmentResidence", valVacancy?.curriculum.province.id);
      setValue("profession", valVacancy?.curriculum?.profession.occupation);
      setValue("formationLevel", valVacancy?.curriculum?.levelEducation);
      setValue("charge", valVacancy?.vacant?.requisition?.chargeRequested?.id);
      setValue("regionalId", valVacancy?.vacant?.requisition?.regional?.id);
      setValue(
        "salary",
        idContractType !== "CONTRATO_PRESTACION_DE_SERVICIO"
          ? valVacancy?.vacant?.salary
          : ""
      );
      getCitysByDeparment(valVacancy?.curriculum.province.id);
      setValue("cityResidence", valVacancy?.curriculum.town.name);
      getProfessionByValue(valVacancy?.curriculum?.profession.occupation);
      setProfessionList(valVacancy?.curriculum?.profession);
      setValue(
        "cellPhoneNumber",
        valVacancy?.curriculum?.person?.cellPhoneNumber
      );
      setValue("phoneUser", valVacancy?.curriculum?.person?.phone);
      setValue("gender", valVacancy?.person?.domainGender);
    }
  };

  const getCityByName = (mapDepartBirth, employee) => {
    setCitys([]);
    const getListTowns = async () => {
      const response = await getTownsByProvinceId(mapDepartBirth);
      setCitys(response?.data?.townList);
      const city = response?.data?.townList.filter(
        (x) => x.name === employee.cityBirth
      );
      const mapCityBirth = city.map((x) => x.name).toString();
      setValue("municipality", mapCityBirth);
    };
    getListTowns();
  };

  const getCityHomeByName = (departResidence, cityResidence) => {
    setCitysResidence([]);
    const getListTowns = async () => {
      const response = await getTownsByProvinceId(departResidence);
      setCitysResidence(response?.data?.townList);
      const city = response?.data?.townList.filter(
        (x) => x.name === cityResidence
      );
      const home = city.map((x) => x.name).toString();
      setValue("cityResidence", home);
    };
    getListTowns();
  };

  const getListDepartmets = (department, employee) => {
    const depart = department.filter(
      (x) => x.name === employee.departmentBirth
    );
    const mapDepartBirth = depart.map((x) => x.id).toString();
    const residence = department.filter(
      (x) => x.name === employee.departmentResidence
    );
    const departResidence = residence.map((x) => x.id).toString();
    if (mapDepartBirth) {
      getCityByName(mapDepartBirth, employee);
      setGetDepartmentId(depart.map((x) => x.name).toString());
    }
    if (departResidence) {
      getCityHomeByName(departResidence, employee?.cityResidence);
    }

    setValue("department", mapDepartBirth);
    setValue("departmentResidence", departResidence);
  };

  const handleDepartment = (e) => {
    const { name, value } = e.target;
    setCitys([]);
    const departmentId = department?.filter((x) => x?.id === value);
    const nameDepartment = departmentId.map((x) => x?.name).toString();
    setGetDepartmentId(nameDepartment);
    setTimeout(() => {
      if (value) {
        setContract({
          ...contract,
          [name]: value,
        });
        const getListTowns = async () => {
          const response = await getTownsByProvinceId(value);
          setCitys(response?.data?.townList);
        };
        getListTowns();
      }
    }, 300);
  };

  const handleDepartmentResidence = (e) => {
    const { name, value } = e.target;
    setCitysResidence([]);
    setTimeout(() => {
      if (value) {
        setContract({
          ...contract,
          [name]: value,
        });
        getCitysByDeparment(value);
      }
    }, 300);
  };

  const getCitysByDeparment = (value) => {
    const getlistTownsResidence = async () => {
      const response = await getTownsByProvinceId(value);
      setCitysResidence(response?.data?.townList);
    };
    getlistTownsResidence();
  };

  function downloadPDF(pdf) {
    const url = `data:@file/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = "contrato.pdf";

    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  const onChangeInfoContract = (e) => {
    const { name, value } = e.target;
    setContract({
      ...contract,
      [name]: value,
    });
  };

  useEffect(() => {
    getValuesFormByPostulate();
    const getListTeachers = async () => {
      const response = await getMaestras();
      setMaestras(response?.data?.maestras);
      return response?.data?.maestras;
    };
    getListTeachers();
  }, []);

  const getProfessionByValue = (e, empty, isRenew) => {
    const value = empty ? e?.target?.value : e;
    const text = value.length === 3 ? value.replace(" ", "") : value;
    if (text?.length > 2) {
      const getAllProfessions = async () => {
        const response = await getProfessionAutocomplete(value);
        let orderProfession = _.sortBy(
          response?.data?.professionList,
          (o) => o.occupation
        );
        setProfessions(orderProfession);
        if (isRenew) {
          setProfessionList(orderProfession[0]);

          setValue("profession", orderProfession[0].occupation);
        }
        if (response?.data.professionList.length === 0) {
          setMessageErrorProfession("Seleccione una profesión registrada");
        }
      };
      getAllProfessions();
    }
  };

  useEffect(() => {
    const getRegional = async () => {
      const response = await getActiveRegionals();
      setRegionals(response?.data?.regionalList);
    };
    getRegional();
  }, []);

  const goToContractList = () => {
    props.history.push("/dashboard/contracts");
    setDisableFinalDate(false);
    setDisableSalary(false);
  };

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
    isDisabledBtnGenerate(false);
  };

  useEffect(() => {
    if (professionList?.length !== 0 || professionList !== null) {
      setMessageErrorProfession("");
    }
  }, [professionList]);

  const onSubmit = (data) => {
    if (
      !professionList?.occupation &&
      !professions.some((p) => p.occupation === professionList.occupation)
    ) {
      setMessageErrorProfession("Seleccione una profesión registrada");
      return;
    }
    const deparmetR = department.filter(
      (x) => x.id === data.departmentResidence
    );
    const deparmentResidence = deparmetR.map((x) => x.name).toString();
    isDisabledBtnGenerate(true);
    let salaryWithoutDots = data?.salary?.replaceAll(".", "");
    const regionalName = regionals.filter((x) => x?.id === data.regionalId);
    const sendRegional = regionalName.map((x) => x.name).toString();
    const selectedCharge = charges.filter((x) => x?.id === data.charge);
    const infoContract = {
      employeeData: {
        firstName: data?.firstName,
        secondName: data?.secondName ? data?.secondName : null,
        surname: data?.surname,
        secondSurname: data?.secondSurname ? data?.secondSurname : null,
        documentType: documentUser?.documentType,
        document: documentUser?.document,
        dateBirth: moment(data.dateBirth).format("YYYY-MM-DDTHH:mm"),
        charge: selectedCharge.map((x) => x.denomination).toString(),
        chargeId: selectedCharge.map((x) => x.id).toString(),
        regional: sendRegional,
        regionalId: data?.regionalId,
        nationality: data?.nationality,
        cityBirth: data?.municipality,
        departmentBirth: getDeparmenId,
        salary: salaryWithoutDots
          ? salaryWithoutDots
              ?.replace(/\$/g, "")
              ?.replace(/\,/g, "")
              ?.replace(/\s+/g, "")
          : null,
        paymentPeriod: data?.paymentPeriod,
        workplace: data?.workplace,
        hiringPlace: data?.hiringPlace,
        workStartDate: data?.workStartDate
          ? moment(data?.workStartDate).format("YYYY-MM-DDTHH:mm")
          : null,
        address: data?.address,
        workEndDate: data?.workEndDate
          ? moment(data?.workEndDate).format("YYYY-MM-DDTHH:mm")
          : null,
        documentIssuancePlace: data?.documentIssuancePlace,
        cityResidence: data?.cityResidence,
        departmentResidence: deparmentResidence,
        profession: professionList?.occupation,
        formationLevel: data?.formationLevel,
        personalEmail: data?.personalEmail ? data?.personalEmail : "",
        apprenticeData: {
          specialty: data?.specialty ? data?.specialty : "",
          groupNumber: data?.groupNumber ? data?.groupNumber : "",
          eps: data?.eps ? data?.eps : "",
          arl: data?.arl ? data?.arl : "",
          stratus: data?.stratus ? data?.stratus : "",
          trainingInstitution: data?.trainingInstitution
            ? data?.trainingInstitution
            : "",
          trainingInstitutionNit: data?.trainingInstitutionNit
            ? data?.trainingInstitutionNit
            : null,
          isSena: isSena,
          trainingCenter: data?.trainingCenter ? data?.trainingCenter : "",
        },
        phone: data.phoneUser ? data.phoneUser : null,
        cellPhoneNumber: data.cellPhoneNumber,
        gender: data.gender,
      },
      idContractTypeFormat: documentUser?.format,
      postulateId: valVacancy?.id ? valVacancy?.id : null,
      chargeIdToReplace: chargesList?.id ? chargesList?.id : "",
      reasonForReplacement: data?.reasonForReplacement
        ? data?.reasonForReplacement.toUpperCase()
        : "",
      employeeNameToReplace: data?.employeeNameToReplace
        ? data?.employeeNameToReplace.toUpperCase()
        : "",
    };
    setMessage({
      description: idContract
        ? "¿Está seguro que desea renovar contrato?"
        : "¿Está seguro que desea generar contrato? ",
      textButtonSubmit: "Guardar",
      handleClick: () => handleClick(infoContract),
      handleClickOut: () => handleClickClose(),
      type: "QUESTION",
      open: true,
    });
  };

  const handleClick = async (infoContract) => {
    setMessage({ ...message, open: false });
    const response = idContract
      ? await renewContract(idContract, infoContract)
      : await saveContract(infoContract);
    const download = response?.data?.documentData;
    if (response && (response?.status === 200 || response?.status === 201)) {
      setIdContractResponse(response?.data?.contractId);
      setDataContract(infoContract);
      setMessage({
        description: `Su contrato ha sido generado de manera exitosa, ¿Desea agregar gastos de representación a este contrato? `,
        textButtonSubmit: "Aceptar",
        handleClick: () => generateExpenses(),
        handleClickOut: () => goToContractList(),
        type: "SUCCESS",
        open: true,
      });
      downloadPDF(download.data);
      isDisabledBtnGenerate(false);
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      isDisabledBtnGenerate(false);
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : `El contrato no ha sido enviado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      isDisabledBtnGenerate(false);
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
    isDisabledBtnGenerate(false);
  };

  const generateExpenses = () => {
    setOpenModalCost(true);
  };

  const onCloseDialogCost = () => {
    setOpenModalCost(false);
  };

  useEffect(() => {
    const getDataCompany = async () => {
      const resp = await getCompany();
      setCompany(resp?.data);
    };
    getDataCompany();
  }, []);

  useEffect(() => {
    const getAllCharges = async () => {
      const response = await getChargesByStatusActive();
      setCharges(response?.data?.chargeList);
    };
    getAllCharges();
  }, []);

  const seeSalary = watch("salary");

  useEffect(() => {
    if (contractSalary) {
      if (seeSalary === "") {
        setStateSalary(true);
      } else {
        setStateSalary(false);
      }
    }

    if (isContractApprenti && isSena) {
      setIsCheckSena(true);
    } else {
      setIsCheckSena(false);
    }
  }, [seeSalary, isSena, isContractApprenti, contractSalary]);

  return (
    <div>
      <InfoContract
        inforContract={contract}
        onChangeInfoContract={onChangeInfoContract}
        onSubmit={onSubmit}
        charges={charges}
        department={department}
        citys={citys}
        handleDepartment={handleDepartment}
        inputDisabled={inputDisabled}
        contract={contract}
        company={company}
        dataUser={dataUser}
        handleDepartmentResidence={handleDepartmentResidence}
        citysResidence={citysResidence}
        maestras={maestras}
        professions={professions}
        regionals={regionals}
        disableFinalDate={disableFinalDate}
        disableSalary={disableSalary}
        isContractApprenti={isContractApprenti}
        isSena={isSena}
        setIsSena={setIsSena}
        idContract={idContract}
        setValue={setValue}
        handleSubmit={handleSubmit}
        errors={errors}
        control={control}
        register={register}
        stateSalary={stateSalary}
        isObraLaborFieldsDisabled={isObraLaborFieldsDisabled}
        setProfessionList={setProfessionList}
        professionList={professionList}
        getProfessionByValue={getProfessionByValue}
        messageErrorProfession={messageErrorProfession}
        setChargesList={setChargesList}
        chargesList={chargesList}
        isLaborDisable={isLaborDisable}
      />

      <ModalConfirm
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={message.open}
      />

      {openModalCost && (
        <DialogCost
          open={openModalCost}
          setOpen={setOpenModalCost}
          data={dataContract}
          handleClose={onCloseDialogCost}
          contractId={idContractResponse}
          props={props}
        />
      )}
    </div>
  );
};

export default withRouter(InfoMainContract);
